import React from 'react';

export interface WishlistItem {
  id: number;
  title: string;
  price: number;
  image: string;
}

interface WishlistContextType {
  wishlist: WishlistItem[];
  addToWishlist: (item: WishlistItem) => void;
  removeFromWishlist: (id: number) => void;
  isInWishlist: (id: number) => boolean;
}

export const WishlistContext = React.createContext<WishlistContextType | undefined>(undefined);

export const useWishlist = () => {
  const ctx = React.useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist deve ser usado dentro do WishlistProvider');
  return ctx;
};

const WISHLIST_KEY = 'gilstore-wishlist';

export const WishlistProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [wishlist, setWishlist] = React.useState<WishlistItem[]>(() => {
    const stored = localStorage.getItem(WISHLIST_KEY);
    return stored ? JSON.parse(stored) : [];
  });

  React.useEffect(() => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  }, [wishlist]);

  const addToWishlist = (item: WishlistItem) => {
    setWishlist(prev => prev.some(i => i.id === item.id) ? prev : [...prev, item]);
  };
  const removeFromWishlist = (id: number) => {
    setWishlist(prev => prev.filter(i => i.id !== id));
  };
  const isInWishlist = (id: number) => wishlist.some(i => i.id === id);

  return (
    <WishlistContext.Provider value={{ wishlist, addToWishlist, removeFromWishlist, isInWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};
